function EmphasizeCrossSection({emphasizeOpt}) {

  const emphasizeFixes = [];
  const linePoints =[];
  for(const fix of emphasizeOpt.fixes) {
    if(fix.fixVisible) {
      emphasizeFixes.push(<div className="emphasize-fix" style={{top: fix.top -8, left: fix.left -6}} key={fix.top}></div>)
    }
    linePoints.push([fix.left, fix.top]);
  }

  let line;
  if(linePoints.length >= 2) {
    line = <svg className="emphasize-route-svg">
      <clipPath id="cut-off-draw-area">
        <rect x={emphasizeOpt.rulerWidth.left}
          y={emphasizeOpt.rulerWidth.top}
          width={`calc(100% - ${emphasizeOpt.rulerWidth.left + emphasizeOpt.rulerWidth.right}px)`} 
          height={`calc(100% - ${emphasizeOpt.rulerWidth.top + emphasizeOpt.rulerWidth.bottom}px)`}/>
      </clipPath>
      <polyline className="emphasize-route" points={linePoints} clipPath="url(#cut-off-draw-area)"  strokeWidth={emphasizeOpt.strokeWidth}></polyline>
    </svg>;
    emphasizeFixes.length = 0;
  }

  return (
    <>
      {line}
      {emphasizeFixes}
    </>
  )
}

export default EmphasizeCrossSection;